import labels from "emun.media/_labels";

export default {
  "Label,Id": "Media #: A to Z",
  "-Label,Id": "Media #: Z to A",
  "ContentType,Id": "Type: A to Z",
  "-ContentType,Id": "Type: Z to A",
  "CreatedOn,Id": "Created On: Newest",
  "-CreatedOn,Id": "Created On: Oldest",
  "LastModifiedOn,Id": "Modified On: Newest",
  "-LastModifiedOn,Id": "Modified On: Oldest",
};
